import type { ReactElement } from "react";

import {
    signalRenewalMonthsToPeriod,
    signalRenewalPeriodOptions,
    signalRenewalPeriodToMonths,
} from "app/pages/sales-intelligence/domain/signals/constants/timeframe";
import type { SignalRenewalPeriod } from "app/pages/sales-intelligence/domain/signals/types/timeframe";
import SignalPeriodsFilter from "app/pages/sales-intelligence/sub-modules/signals/components/filters/SignalPeriodsFilter/SignalPeriodsFilter";
import trackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/trackingService";

type Props = {
    months: number | undefined;
    signalAlias: string;
    onChange(months: number): void;
};

const SignalRenewalPeriodFilter = ({ months, signalAlias, onChange }: Props): ReactElement => {
    const handlePeriodChange = (period: SignalRenewalPeriod) => {
        trackingService.filters.trackTractionPeriodChange(period, signalAlias);
        onChange(signalRenewalPeriodToMonths[period]);
    };

    return (
        <SignalPeriodsFilter<SignalRenewalPeriod>
            selectedValue={months == null ? undefined : signalRenewalMonthsToPeriod[months]}
            options={signalRenewalPeriodOptions}
            onValueChange={handlePeriodChange}
        />
    );
};

export default SignalRenewalPeriodFilter;
